import { isChordLine } from './chordPatterns';
import { INSTRUMENTAL_PARTS } from './parts';

export function removeChords(songPart) {
  const excludedParts = ['Note'];
  const instrumentParts = INSTRUMENTAL_PARTS;
  let lyrics = songPart.lyrics;
  let lines = lyrics.split(/\r\n|\r|\n/);

  // Skip excluded parts
  if (excludedParts.includes(songPart.name)) return songPart;

  // Test if any of the lyric lines have a chord
  if (!instrumentParts.includes(songPart.name)) {
    lines.forEach((line, index) => {
      if (isChordLine(line)) {
        lines[index] = null;
      } else {
        // Remove any extra white spaces
        let str = line.replace(/\s\s+/g, ' ').trimStart().trimEnd();
        lines[index] = str;
      }
    });
  }

  // Musical Parts | Add '♫' to any instrument parts
  if (instrumentParts.includes(songPart.name)) {
    songPart.lyrics = '♫';
    // Its chart is drawn in the lyrics' place, so it goes with them
    delete songPart.chartData;
  } else {
    // Other Parts
    // Remove lines with chords
    lines = lines.filter((line) => line !== null);
    // Join remaining lyric lines together
    songPart.lyrics = lines.join('\r');
  }

  return songPart;
}

export function removeSongChords(song) {
  const songParts = JSON.parse(JSON.stringify(song.parts)); // ? 👀

  songParts.forEach((songPart, index) => {
    songParts[index] = removeChords(songPart);
  });

  return songParts;
}
